<script setup lang="ts">
import Sidebar from 'primevue/sidebar';
import { useAppLayoutStateStore } from '../stores/app-layout-state';
import { useAppRightPanelStore } from '../stores/app-right-panel';
import { RightpanelSectionReceiver } from '@precon-tools-suite-by-shared/primevue-receivers';

const appState = useAppLayoutStateStore();

const rightBarStore = useAppRightPanelStore();
</script>

<template>
    <Sidebar
        v-model:visible="appState.rightMenuActive"
        position="right"
        class="layout-profile-sidebar w-full sm:w-30rem"
    >
        <template
            v-for="partial in rightBarStore.sectionPartials"
            :key="partial"
        >
            <RightpanelSectionReceiver collapsable :partial="partial" />
        </template>
    </Sidebar>
</template>
